import React, { useState } from "react";
import { Typography , Grid, Box} from "@mui/material";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { styled } from "@mui/material/styles";
import DoneIcon from '@mui/icons-material/Done'
import EditableText from '../../../shared/EditTableText'
const trasnlateMark = {
    fontSize: "14px",
    transform: "translate(0px,-1px)",
  };
const Accordions = styled((props) => (
    <Accordion  disableGutters elevation={0} square {...props} />
  ))(() => ({
    
        backgroundColor:"#fff",
        marginBottom:"10px",
        boxShadow: "0 1px 2px 1px rgba(0,0,0,0.06)",
        borderRadius:"12px",
    "&:before": {
      display: "none",
    },
    
  }));

  const AccordionDetailss = styled(AccordionDetails)(({ theme }) => ({
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(5),
    backgroundColor:"#fff",
    
    borderEndStartRadius:"12px",
    borderEndEndRadius:"12px"
  }));

  const AccordionSummarys = styled((props) => (
    <AccordionSummary
   
    
      expandIcon={<ExpandMoreIcon sx={{ fontSize: '15px' }} />}
      {...props}
    />
  ))(({ theme }) => ({
    boxSizing: "border-box",
    height: "67px",
    alignItems:"center",
    minHeight: "67px",

    flexDirection: "row-reverse",
   
 "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
      transform: "rotate(180deg)",
    },
    "& .MuiAccordionSummary-expandIconWrapper": {
        color: "#50566E",
        fontWeight: "400",
        backgroundColor:"#E7E9EF",
        borderRadius:"50%",
        padding:"5px"
     
     
      },
   
    "& .MuiAccordionSummary-content": {
      color: "#50566E",
      fontSize: ".875rem",
      fontWeight: "550",
      lineheight: "16px",
    },
  
  }));

  const CustomSubTypography = styled((props) => <Typography {...props} />)(() => ({
    color: "#050D2E",
    fontSize: "13px",
    fontWeight: "500",
    lineheight: "15px",
    textTransform:"lowercase",
    "&:first-letter": {
      textTransform:"capitalize !important"
    }
  }));


const CustomAccordion = ({
  children,
  groupName,
  group,
  menu,
  Descreption,
  renamingGroup,
  setRenamingGroup,
  handleRenameGroup,
  makeasDefault,
  index,
  alerts,
  values,
  setValues,
  action,
  setDirty,
  expanded,
  setExpanded,
  disableMenu = true
}) => {
  
  const [anchorEl, setAnchorEl] = useState(null);
  const [hover , setHover] = useState(false)
  const [finalMenu, setFinalMenu] = useState(menu);
  const [templateValue, setTemplateValue] = useState({name:group.name})
  const [oldValue, setOldValue] = useState({name:group.name})


  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
    e.stopPropagation();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  const handleChange = (id) => (event, newExpanded) => {
    
    setExpanded(newExpanded ? id : false);
  };

  const loadMenu = (group,el) => {
    const alertType = group.alertType
    switch (alertType) {
      case "AMOUNT":
        return(
          <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            el.handler(group,index);
            handleClose();
          }}
       disabled={el.id === 3 ? group.isDefault : false}
         >
          {el.action}
        
          </MenuItem>
        );
      case "TEXT":
  return(
    <MenuItem
    onClick={(e) => {
      e.stopPropagation();
      el.handler(group,index);
      handleClose();
    }}
    disabled={el.id === 3 ? group.isDefault : false}
   >
    {el.action}
    </MenuItem>
  );
    case "MATCHING":
  return(
    <MenuItem
    onClick={(e) => {
      e.stopPropagation();
      el.handler(group,index);
      handleClose();
    }}
    disabled={el.id === 3 ? group.isDefault : false}
   >
    {el.action}
    </MenuItem>
  );
  case "GPI":
return(
  <MenuItem
  onClick={(e) => {
    e.stopPropagation();
    el.handler(group,index);
    handleClose();
  }}
   disabled={el.id === 3 ? group.isDefault : false}
 >
  {el.action}
  </MenuItem>
);
      default:
        return(
          <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            el.handler(group,index);
            handleClose();
          }}
           disabled={el.id === 3 ? group.isDefault : false}
         >
          {el.action}
          </MenuItem>
        );
    }
  }
    

  const changeHeaderGroup = (key, value) => {
    
  setOldValue({...oldValue,[key]:values.name})
    setTemplateValue({ ...templateValue, [key]: value });
    const  newTemplates =  {
      ...values,
     name:value
     
        
      }
      setValues(newTemplates)
      
      setDirty(true)
  };

  return (
 
      <Accordions 
      className="test"
      expanded={expanded === group.id}
            onChange={handleChange(group.id)}
      >
        <AccordionSummarys
          expandIcon={<ExpandMoreIcon fontSize="15px" />}
          aria-controls={`${group.id}-content`}
              id={`${group.id}-header`}
          style={{ flexDirection: "row-reverse" }}
          onMouseEnter = {() => setHover(true)}
          onMouseLeave = {() => setHover(false)}
          focusVisibleClassName="focusVisible"
        >
               <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            alignSelf={"center"}
            alignContent="center"
            gap={10}
          >
            <Grid item flex={1}  >
              <Grid container alignItems="center" >  
                <Grid flex={1} item sx={{ marginLeft: "5px"}}>
            
      
                
               {disableMenu  ? <EditableText
                    inputValue={templateValue?.name}
                    placeholder="name"
                    inputClass="head-title"
                    onChange={(value) => changeHeaderGroup("name", value)}
                    attr="name"
                   action = {action}
                   oldvalue={oldValue}
                    /> :<Typography sx={{fontWeight:"bold", color: "#050D2E",  fontSize: "14px",
                    
                    lineheight: "16px",}}>
                  {templateValue?.name}
                  </Typography>   }
               
                  <CustomSubTypography>
                    {group.alertType || group.timingType}
                  </CustomSubTypography>
                </Grid>
              </Grid>
            </Grid>
{ disableMenu &&             <Grid sx={{
                display:"flex",
                gap: "20px",             
                alignItems:"center",
        
        }}>
               {group.isDefault === false && 
               
               <Typography
               sx={{
                  color: "#007AFF",
                  fontSize: ".775rem",
                  lineHeight: "16px",
                  cursor: "pointer",
                  textDecorationColor: "#007AFF",
                  visibility: hover ? "visible" : "hidden"
                
                }}

                onClick ={ (e) => makeasDefault(e , group)}
              >

             <div > Set As default Template</div>
              </Typography>
               }
                {group.isDefault === true && 
                <Box sx={{display:"flex" , justifyContent:"center" , alignItems:"center"  ,padding:"2px 1px"}} className="default-div">
              <Box sx={{margin:"1px"}}>Default</Box>
              
                <DoneIcon style={trasnlateMark} />
              
            </Box>}
            <MoreHorizIcon 
            sx={{ color: "#50566E" }}
            aria-controls="accordian-menu"
            aria-haspopup="true"
            onClick={finalMenu?.length ? handleClick : null}
            />
            <Menu
                    id="accordian-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
             
                  >
                    {React.Children.toArray(finalMenu.map((el) => {
                      
                      
                      
                      return (
                        <div style={{ width: "200px"}}>
                          
                          { loadMenu(group,el) }
                        
                      
                         
                        </div>
                      );
                    }))}
                  </Menu>
            </Grid>}
          </Grid>
     {/*      <div className="w-100">
            <div className="d-flex justify-content-between align-items-center">
              {rename &&
              (renamingGroup.id === group.id ||
                renamingGroup.index === group.index) ? (
                <input
                  onKeyDown={(e) => handleInlineEdit(e, group?.id)}
                  className="form-control"
                  value={value}
                  onChange={(e) => {
                    setValue(e.target.value);
                  }}
                  onBlur={() => {
                    setRename(false);
                  }}
                />
              ) : (
                <span className="d-block un-selected-span mx-2 " style={{ visibility: hover ? "visible" : "hidden"}}>
                  {`${groupName}`}
                </span>
              )}
             
                <div className="d-flex align-items-center">
                  <MoreHorizIcon
                    aria-controls="accordian-menu"
                    aria-haspopup="true"
                    onClick={finalMenu?.length ? handleClick : null}
                  />
                  <Menu
                    id="accordian-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                  >
                    {finalMenu?.map((el) => {
                      return (
                        <div style={{ width: "200px" }}>
                          <MenuItem
                            onClick={(e) => {
                              e.stopPropagation();
                              el.handler(group);
                              handleClose();
                            }}
                          >
                            {el.action}
                          </MenuItem>
                        </div>
                      );
                    })}
                  </Menu>
                </div>
           
            </div>
          </div> */}

          
        </AccordionSummarys>
        <AccordionDetailss>

          <div>{children}
         
          </div>
        </AccordionDetailss>
      </Accordions>
    
  );
};

export default CustomAccordion;
